import { useEffect, useState } from "react";
import { Button, Col, PageHeader } from "antd";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import LayoutCss from "layout/layout.module.scss";
import RoleAndPermission from "redux/models/roleAndPermission";
import { selectUser, selectUserId } from "redux/slices/userSlice";
import K from "utilities/constants";
import { DataTableLayout } from "../../../common/components/dataTableLayout/dataTableLayout";
import { ClientSideDataGrid } from "../../../common/components/clientSideDataGrid/clientSideDataGrid";
import { usePageFilter } from "../../../hooks/usePageFilters";
import { getColumns } from "./columns";

export default function RolesPermission() {
  const userId = useSelector(selectUserId);
  const userSlice = useSelector(selectUser);

  const [search, setSearch] = usePageFilter("roles_and_permission_search");
  const [roles, setRoles] = useState([]);

  const getAllRoles = async () => {
    const res = await RoleAndPermission.getAllRoles();
    setRoles(res);
  };

  useEffect(() => {
    getAllRoles();
  }, []);

  return (
    <>
      <PageHeader
        ghost={false}
        title="Roles & Permissions"
        className={LayoutCss.appPageHeader}
      />

      <DataTableLayout
        searchDefaultValue={search}
        onSearchChange={setSearch}
        actions={[
          {
            permissions: [K.Permissions.CreateRole],
            renderer: () => (
              <Col>
                <Link to="/configurations/roles-permission/create">
                  <Button type="primary">Create Role</Button>
                </Link>
              </Col>
            ),
          },
        ]}
      >
        <ClientSideDataGrid
          userId={userId}
          configKey={K.AgGridTable.Keys.RolePermissionsVisibleColumn}
          defaultColumnConfig={getColumns(userSlice.roles)}
          rowData={roles}
          quickFilterText={search}
        />
      </DataTableLayout>
    </>
  );
}
